module.exports = __webpack_public_path__ + "media/theme/icon__stock--out-003c7a3d.png";